import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';

export const merchantRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/merchant',
  component: lazyRouteComponent(() => import('@/pages/merchant/merchant-page')),
});

export const detailMerchantRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/merchant/$id',
  component: lazyRouteComponent(() => import('@/pages/merchant/merchant-detail-page')),
});
